<template>
  <div>
    <div class="box">
      <h2 class="subtitle">
        <span class="icon"><i class="fa fa-users"></i></span>
        {{ $t("references in usa") }}
      </h2>

      <div
        v-for="(reference, index) in formData.usReferences"
        :key="`us-${index}`"
        class="mb-4"
      >
        <div class="columns">
          <div class="column is-half">
            <div class="field">
              <label class="label">{{ $t("reference name") }} *</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  :value="reference.nombre"
                  @input="
                    $emit(
                      'update-us-reference-name',
                      index,
                      $event.target.value
                    )
                  "
                  :placeholder="
                    $t('reference name placeholder', { number: index + 1 })
                  "
                  required
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-user"></i>
                </span>
              </div>
            </div>
          </div>

          <div class="column is-half">
            <div class="field">
              <label class="label">{{ $t("phone") }} *</label>
              <div class="control has-icons-left has-icons-right">
                <input
                  class="input"
                  type="tel"
                  :value="reference.telefono"
                  @input="
                    $emit(
                      'update-us-phone-reference',
                      index,
                      $event.target.value
                    )
                  "
                  placeholder="5551234567"
                  required
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-phone"></i>
                </span>
                <span
                  class="icon is-small is-right"
                  v-if="formData.usReferences.length > 1"
                >
                  <button
                    type="button"
                    class="delete"
                    @click="$emit('remove-us-reference', index)"
                  ></button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <div class="control">
          <button
            type="button"
            class="button is-light"
            @click="$emit('add-us-reference')"
          >
            <span class="icon"><i class="fa fa-plus"></i></span>
            <span>{{ $t("add another usa reference") }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="box">
      <h2 class="subtitle">
        <span class="icon"><i class="fa fa-users"></i></span>
        {{ $t("references in guatemala") }}
      </h2>

      <div
        v-for="(reference, index) in formData.guatemalaReferences"
        :key="`gt-${index}`"
        class="mb-4"
      >
        <div class="columns">
          <div class="column is-half">
            <div class="field">
              <label class="label">{{ $t("reference name") }} *</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  :value="reference.nombre"
                  @input="
                    $emit(
                      'update-guatemala-reference-name',
                      index,
                      $event.target.value
                    )
                  "
                  :placeholder="
                    $t('reference name placeholder', { number: index + 1 })
                  "
                  required
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-user"></i>
                </span>
              </div>
            </div>
          </div>

          <div class="column is-half">
            <div class="field">
              <label class="label">{{ $t("phone") }} *</label>
              <div class="control has-icons-left has-icons-right">
                <input
                  class="input"
                  type="tel"
                  :value="reference.telefono"
                  @input="
                    $emit(
                      'update-guatemala-phone-reference',
                      index,
                      $event.target.value
                    )
                  "
                  placeholder="12345678"
                  required
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-phone"></i>
                </span>
                <span
                  class="icon is-small is-right"
                  v-if="formData.guatemalaReferences.length > 1"
                >
                  <button
                    type="button"
                    class="delete"
                    @click="$emit('remove-guatemala-reference', index)"
                  ></button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <div class="control">
          <button
            type="button"
            class="button is-light"
            @click="$emit('add-guatemala-reference')"
          >
            <span class="icon"><i class="fa fa-plus"></i></span>
            <span>{{ $t("add another guatemala reference") }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReferencesStep",
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  emits: [
    "update-us-reference-name",
    "update-guatemala-reference-name",
    "update-us-phone-reference",
    "update-guatemala-phone-reference",
    "add-us-reference",
    "remove-us-reference",
    "add-guatemala-reference",
    "remove-guatemala-reference",
  ],
};
</script>
